import moment from 'moment-timezone';
moment.tz.setDefault('UTC');
export default moment;
